import React                                        from 'react';
import { GoogleMap as Map, LoadScriptNext, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '600px',
  height: '600px'
};

const libraries = [ 'places' ];

export class GoogleMap extends React.Component {

  center = { lat: 51.2032088, lng: 10.4060168 };
  zoom = 13;

  static defaultProps = {
    showPicker: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      center: { lat: props.lat || this.center.lat, lng: props.lng || this.center.lng },
      zoom: props.zoom || this.zoom,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.lng !== prevProps.lng || this.props.lat !== prevProps.lat || this.props.zoom !== prevProps.zoom) {
      this.setState(() => ({
        center: { lat: this.props.lat, lng: this.props.lng },
        zoom: this.props.zoom || this.zoom,
      }));
    }
  }

  handleOnUnmount = () => {

  };

  render() {

    return (
      <LoadScriptNext
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        onUnmount={this.handleOnUnmount}
        libraries={libraries}
      >
        <Map
          mapContainerStyle={this.props.mapStyle || containerStyle}
          center={this.state.center}
          zoom={this.state.zoom}
          {...this.props}
        >
          {this.props.showPicker ? <Marker position={this.state.center}/> : null}

        </Map>
      </LoadScriptNext>
    );
  }

}
